var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
export var formikCreateUpdateInitialValue = {
    vehicle_number: '',
    position: null,
    software_version: '',
    status: null,
    rdv: '',
    vehicle_group: '',
    first_communication_datetime: '',
    last_communication_datetime: '',
};
export var formikFilterInitialValue = {
    vehicle_number: null,
    route: null,
    geofence: null,
    status: null,
};
export var formikFilterPermissionInitialValue = {
    screen_name: null,
    function_name: null,
    app_name: null,
};
var initialState = {
    pending: false,
    data: {
        errorCode: '',
        data: {
            displayCount: 0,
            filterCount: 0,
            display: [],
        },
        errorMessage: '',
        errorParam: '',
        status: '',
    },
    error: null,
};
var displaySlice = createSlice({
    name: 'display',
    initialState: initialState,
    reducers: {
        getAllDisplayRequest: function (state) {
            return __assign(__assign({}, state), { pending: true });
        },
        getAllDisplaySuccess: function (state, action) { return (__assign(__assign({}, state), { pending: false, data: action.payload.data, error: null })); },
        getAllDisplayFailed: function (state, action) { return (__assign(__assign({}, state), { pending: false, error: action.payload.error })); },
    },
});
export var getAllDisplaySuccess = (_a = displaySlice.actions, _a.getAllDisplaySuccess), getAllDisplayFailed = _a.getAllDisplayFailed;
export default displaySlice.reducer;
